import {Route, Routes, BrowserRouter} from 'react-router-dom'
import NotFound from '../Page/NotFound'
import Dashboard from '../Page/Dashboard'
import Consumers from '../Page/Consumers'
import Login from '../Page/Login'
import Meters from '../Page/Meters'
import Rates from '../Page/Rates'
import RatesCalendar from '../Page/RatesCalendar'
import Sites from '../Page/Sites'
import Structures from '../Page/Structures'
import Users from '../Page/Users'
import RouteManager from './RouteManager'
import MetersReading from 'Page/MetersReading'
import FaultLog from 'Page/FaultLog'
import Invoice from 'Page/Invoice'
import AccountReport from 'Page/AccountReport'
import Signup from 'Page/Signup'
import ForgotPassword from 'Page/ForgotPassword'
import Settings from 'Page/Settings'
import MyProfile from 'Page/MyProfile'
import Payment from 'Page/Payment'
import Payments from 'Page/Payments'
import Queue from 'Page/Queue'

const ProtectedRoute = RouteManager.ProtectedRoute
const OutRoute = RouteManager.OutRoute
const AccessGuard = RouteManager.AccessGuard
const AccountSelected = RouteManager.AccountSelected
const SuperUserGuard = RouteManager.SuperUserGuard

const NavigationRouter = () => {
    return (
        <BrowserRouter future={{v7_relativeSplatPath: true}}>
            <Routes>
                <Route path="/payment/:token" element={<Payment />} />
                <Route element={<OutRoute />}>
                    <Route path="/Login" element={<Login />} />
                    <Route path="/signup/:token" element={<Signup />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/forgot-password/:token" element={<ForgotPassword />} />
                    <Route exac path="/" element={<Login />} />
                </Route>
                <Route element={<ProtectedRoute />}>
                    <Route exac path="/" element={<Dashboard />} />
                    <Route exac path="/dashboard" element={<Dashboard />} />
                    <Route
                        path="/consumers"
                        element={
                            <AccessGuard resource="CONSUMERS">
                                <Consumers />
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/meters"
                        element={
                            <AccessGuard resource="METERS">
                                <Meters />
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/rates/new"
                        element={
                            <AccessGuard resource="RATES">
                                <RatesCalendar />
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/rates"
                        element={
                            <AccessGuard resource="RATES">
                                <Rates />
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/sites"
                        element={
                            <AccountSelected resource="ACCOUNTS">
                                <Sites />
                            </AccountSelected>
                        }
                    />
                    <Route
                        path="/structures"
                        element={
                            <AccessGuard resource="STRUCTURES">
                                <Structures />
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/users"
                        element={
                            <AccessGuard resource="USERS">
                                <Users />
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/meter_readings"
                        element={
                            <AccessGuard resource="METERS_READING">
                                <MetersReading />
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/fault_logs"
                        element={
                            <AccessGuard resource="FAULT_LOG">
                                <FaultLog />
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/invoices"
                        element={
                            <AccessGuard resource="INVOICES">
                                <Invoice />
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/account_reports"
                        element={
                            <AccessGuard resource="ACCOUNT_REPORTS">
                                <AccountReport />
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/payments"
                        element={
                            <AccessGuard resource="PAYMENTS">
                                <Payments />
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/settings"
                        element={
                            <AccessGuard resource="CONFIGS">
                                <Settings />{' '}
                            </AccessGuard>
                        }
                    />
                    <Route
                        path="/queues"
                        element={
                            <SuperUserGuard>
                                <Queue />
                            </SuperUserGuard>
                        }
                    />
                    <Route path="/my-profile" element={<MyProfile />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export default NavigationRouter
